import {ActionTypes} from '../actions';
import createReducer from '../../common/util/createReducer';

const INITIAL_STATE_CAMPAIGN_QUERY = {
  'list': [],
  'loading': false,
  'loadingExcelFile': false,
  'excelFile': '',
};

export const warrantyCampaigns = (state, action) => {
  return createReducer(INITIAL_STATE_CAMPAIGN_QUERY, {
    [ActionTypes.FETCHING_WARRANTY_CAMPAIGNS]: (state, action) => ({
      ...state,
      'loading': true,
    }),
    [ActionTypes.FETCHED_WARRANTY_CAMPAIGNS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': action.response.data,
    }),
    [ActionTypes.FETCHED_WARRANTY_CAMPAIGNS_FAILED]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.CLEAR_WARRANTY_CAMPAIGNS]: (state, action) => ({
      ...state,
      'loading': false,
      'list': [],
    }),
    [ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_REQUEST]: (state, action) => ({
      ...state,
      'loadingExcelFile': true,
    }),
    [ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_SUCCESS]: (state, action) => ({
      ...state,
      'loadingExcelFile': false,
      'excelFile': action.response.data,
    }),
    [ActionTypes.DOWNLOAD_WARRANTY_CAMPAIGNS_EXCEL_FAILED]: (state, action) => ({
      ...state,
      'loadingExcelFile': false,
      'excelFile': '',
    }),
    [ActionTypes.CLEAR_WARRANTY_CAMPAIGNS_EXCEL_FILE]: (state, action) => ({
      ...state,
      'excelFile': '',
    }),
  })(state, action);
};

